import React from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import Pane from 'components/Common/Pane'
import config from 'constants/config'
import { mediaQueryUp } from 'components/utils/breakpoint'
import Heading from 'components/Luxkit/Typography/Heading'
import LoadingBox from 'components/Common/Loading/LoadingBox'
import LayoutContainer from 'components/Common/LayoutContainer'

const SummaryPlaceholder = styled(Pane)`
  height: ${rem(500)};
`

const PackageOptionsPlaceholder = styled(Pane)`
  height: ${rem(700)};
  padding: ${rem(20)};

  ${mediaQueryUp.tablet} {
    padding: ${rem(24)} ${rem(40)};
  }

  ${mediaQueryUp.desktop} {
    padding: ${rem(62)} ${rem(12)};
  }
`

const OfferHeaderPlaceholder = styled(Pane)`
  display: flex;
  height: ${rem(64)};
  position: sticky;
  z-index: 3;
  top: 0;

  ${mediaQueryUp.desktop} {
    height: ${rem(60)};
  }
`

const ImagePlaceholder = styled(LoadingBox)`
  aspect-ratio: 3 / 2;

  ${mediaQueryUp.tablet} {
    aspect-ratio: 16 / 9;
  }
`

function OfferContentLoader() {
  return (
    <div>
      <OfferHeaderPlaceholder />
      <Pane>
        <LayoutContainer>
          <ImagePlaceholder />
        </LayoutContainer>
      </Pane>
      <SummaryPlaceholder />
      <PackageOptionsPlaceholder background="neutral-six">
        <Heading variant="heading3" format="titlecase" align="center" colour="neutral-one">
          {config.brandConfig.travelSynonym} Options
        </Heading>
      </PackageOptionsPlaceholder>
    </div>
  )
}

export default OfferContentLoader
